module.exports = __webpack_public_path__ + "static/img/25.1322ea35.jpg";